import TagManager from 'react-gtm-module';

import { GTM } from '@/services/Config.js';

import { getGlobalAnalyticsParams } from './global-params.ts';

const envs = {
  dev: {
    auth: 'Qt1PyqNroNqhIHL5HuzlxQ',
    preview: 'env-7',
  },
  prod: {
    auth: 'xD4PUOPlW6TgqTuA3fxYOg',
    preview: 'env-2',
  },
  alpha: {
    auth: 'SmCkqVYrYDiyX39pSOE11g',
    preview: 'env-33',
  },
  poc: {},
};

const envVariable: Record<string, any> = {
  localhost: { ...envs.dev },
  'hudya.no': { ...envs.prod },
  'scoopr.no': { ...envs.prod },
  'dev.scoopr.no': { ...envs.dev },
  'alpha.scoopr.no': { ...envs.poc },
  'sandbox.scoopr.no': { ...envs.poc },
};

export const initializeGTM = () => {
  TagManager.initialize({
    gtmId: GTM.id,
    ...envVariable[window.location.hostname],
  });
};

const addValue = (value: object, parameters?: object | void) => {
  const globalParams = getGlobalAnalyticsParams();

  const dataLayerObj = {
    ...globalParams,
    ...value,
    ...parameters,
  };

  TagManager.dataLayer({
    dataLayer: dataLayerObj,
  });
};

/** Do not use this function directly, use unified analytics instead */
export const addGTMValue = (value: object) => addValue(value);

export const getGaClientId = () => {
  const ga = (window as any).ga;

  if (!ga) {
    return '';
  }

  let clientId = '';
  ga((tracker: any) => {
    clientId = tracker.get('clientId');
  });
  return clientId;
};
